// スクロールアニメーション
document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // アニメーション対象要素
  document.querySelectorAll('.award-item, .youtube-content, .vb-content-card').forEach(el => {
    observer.observe(el);
  });
});



// スクロールアニメーション
document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // アニメーション対象要素
  document.querySelectorAll('.award-item, .youtube-content, .vb-content-card').forEach(el => {
    observer.observe(el);
  });
});

// アイコン横流し + タップ拡大
(function() {
  var track = document.getElementById('vbIconsTrack');
  if (!track) return;

  // 無限ループ用に複製
  var clone = track.cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  var wrap = track.parentElement;
  wrap.appendChild(clone);

  var pos = 0;
  var speed = 0.6; // px/frame
  var isPaused = false;
  var trackWidth = track.scrollWidth + 16; // gap分

  function tick() {
    if (!isPaused) {
      pos += speed;
      if (pos >= trackWidth) pos -= trackWidth;
      wrap.scrollLeft = pos;
    }
    requestAnimationFrame(tick);
  }
  wrap.style.overflowX = 'hidden';
  wrap.style.scrollBehavior = 'auto';
  requestAnimationFrame(tick);

  wrap.addEventListener('mouseenter', function() { isPaused = true; });
  wrap.addEventListener('mouseleave', function() { isPaused = false; });

  // タップ/クリックで拡大（オリジナル・クローン両方に対応）
  var modal = document.getElementById('vbIconModal');
  var modalImg = document.getElementById('vbIconModalImg');
  var modalTitle = document.getElementById('vbIconModalTitle');
  var modalDesc = document.getElementById('vbIconModalDesc');
  var modalClose = document.getElementById('vbIconModalClose');

  function openModal(card) {
    var img = card.querySelector('img');
    modalImg.src = img.src;
    modalImg.alt = img.alt;
    modalTitle.textContent = card.dataset.title || '';
    modalDesc.textContent = card.dataset.desc || '';
    modal.classList.add('is-open');
    isPaused = true;
  }

  function closeModal() {
    modal.classList.remove('is-open');
    isPaused = false;
  }

  wrap.addEventListener('click', function(e) {
    var card = e.target.closest('.vb-icon-flow-card');
    if (card) openModal(card);
  });

  modalClose.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });
})();